import React, { useState } from "react";
import axios from "axios";
import { useContext } from "react";
import RegistrationContext from "../../contexts/RegistrationContext";
import { base_url } from "../../config";
import RegistrationNotice from "../../components/RegistrationNotice/RegistrationNotice";

export default function LoginScreen() {
  const [rememberMe, setRememberMe] = useState(false)

  const [formEmail, setFormEmail] = useState("");
  const [password, setPassword] = useState("");

  const {
    setScreen,
    setAuthenticated,
    setError,
    reload,
    setReload,
    setEmail,
    email,
  } = useContext(RegistrationContext);
  const handleSubmit = async (event) => {
    event.preventDefault();

    // Reset login error state
    setError("");

    try {
      // Make a POST request to your authentication endpoint
      const response = await axios.post(`${base_url}/api/login`, {
        email: formEmail,
        password: password,
      });

      setAuthenticated(true);
      localStorage.setItem("token", response.data.access_token);
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${response.data.access_token}`;
      setReload(reload + 1);
      setEmail(formEmail);
    } catch (error) {
      setError("Login failed. " + error.response.data.message);
    }
  };

  return (
    <main className="flex-1">
      <div className="container mx-auto px-4">
        {/* Welcome Message */}
        <div className="text-center py-8">
          <h2 className="text-2xl font-medium text-gray-800">Welcome to the IJCAI-ECAI 2026 registration system</h2>
        </div>

        {/* Login Form */}
        <div className="max-w-3xl mx-auto py-8">

          <div className="bg-white rounded-xl shadow-lg p-8">
            <form onSubmit={handleSubmit} className="flex flex-col gap-6">
            <h2 className="text-2xl font-bold text-gray-800">Login with Email & Password</h2>
              <div className="flex flex-col md:flex-row items-center gap-4">
                <label
                  htmlFor="email"
                  className="md:w-40 text-right md:text-left font-medium text-gray-700"
                >
                  E-Mail Address
                </label>
                <input
                  id="email"
                  type="email"
                  value={formEmail}
                  onChange={(e) => setFormEmail(e.target.value)}
                  required
                  className="w-full max-w-md px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="your@email.com"
                />
              </div>

              <div className="flex flex-col md:flex-row items-center gap-4">
                <label
                  htmlFor="password"
                  className="md:w-40 text-right md:text-left font-medium text-gray-700"
                >
                  Password
                </label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="w-full max-w-md px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="••••••••"
                />
              </div>

              <div className="flex flex-wrap items-center gap-4">
                <button
                  type="submit"
                  className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-lg transition-colors"
                >
                  Login
                </button>
                <div className="text-sm text-gray-600">
                or &nbsp;
                
                <a href="#" onClick={() => setScreen("forgotpass")} className="text-sm text-blue-600 hover:text-blue-800 hover:underline transition-colors">
                Use code to log in 
                </a>
               
                &nbsp; • &nbsp;
                <a href="#" onClick={() => setScreen("signin")} className="text-sm text-blue-600 hover:text-blue-800 hover:underline transition-colors">
                Create account
                </a>
                </div>
   
              </div>
            </form>
          </div>
        </div>

        <RegistrationNotice />
        
      </div>
    </main>
  )
}
